import React from 'react'

import currency from 'currency.js';
import { useTranslation } from 'react-i18next'
import { type WebCart } from '../../common/types/webshop.types';
import { formatCurrency } from '../../common/js/currency-utility';
import { getProductImageForDisplay } from '../../common/js/product-image-utility';

type Props = {
    order: WebCart,
    isBfxd: Boolean
}

export default function ProductDetails({ order, isBfxd }: Props) {
    if (!order) {
        return <></>
    }

    const { t } = useTranslation('common', {keyPrefix: 'purchase'});

    const elements = [];
    for (let i = 0; i < order.lineItems.length; i++){
        const item = order.lineItems[i]
        const product = item.product;
    
        const price = formatCurrency(item.unitPrice, order.currencyIso);
        const listPrice = formatCurrency(item.listPrice, order.currencyIso);
        const isDiscount = item.unitPrice != item.listPrice;

        if (!isBfxd){
            elements.push((
                <div className='line-items box'>
                    <div className='d-flex'>
                        <div className='line-item-image-container'>
                            <img
                                className="line-item-image"
                                src={getProductImageForDisplay(product.familyName, product.imgSrc)}
                                alt={product.familyName}
                            />
                        </div>
                        <div className='product-details'>
                            <span className='product-host'>{product.host}</span>
                            <span className='product-type'>{product.typeLabel || product.type}</span>
                            <span className='product-serial'>{item.serial}</span>
                        </div>
                    </div>
                    <div className='line-item-details'>
                        <div className='line-item-field'>
                            <label>{t('quantity')}</label>
                            <span>{item.quantity}</span>
                        </div>
                        <div className='line-item-field'>
                            <label>{t('price')}</label>
                            <span className={isDiscount ? 'line-item-discount' : ''}>{price}
                                {isDiscount && (
                                    <span className='line-item-list-price'>{listPrice}</span>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            ));
        }
        else{
            elements.push((
                <div className='line-items box'>
                    <div className='d-flex align-items-center'>
                        <div className='line-item-image-container'>
                            <img
                                className="line-item-image"
                                src={getProductImageForDisplay(product.familyName, product.imgSrc)}
                                alt={product.familyName}
                            />
                        </div>
                    </div>
                    <div className='line-item-details'>
                        <ul>
                            <li>{product.hostLabel}</li>
                            <li>{product.typeLabel}</li>
                        </ul>
                    </div>
                </div>

            ));
        }
    }

    return (
        <div className='line-items-container'>
            {elements}
        </div>
    )
}
